import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerActions } from "../actions/consumer.actions";
import { ConsumerState } from "../models/consumer-state";

const initialState: ConsumerState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerActions.account.getApi, (state) => getApi(state)),
	on(ConsumerActions.consumer.getApi, (state) => getApi(state)),
	on(ConsumerActions.account.getSuccess, (state, action) => _.omit(action, "type")),
	on(ConsumerActions.consumer.getSuccess, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, ["type", "anCustomerProfile", "fundingSources"]))
	),
	on(ConsumerActions.account.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	),
	on(ConsumerActions.consumer.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function consumerReducer(state: ConsumerState | undefined, action: Action): ConsumerState {
	return reducer(state, action);
}

function getApi(state: ConsumerState): ConsumerState {
	const cloned = _.cloneDeep(state);
	cloned.loading = true;
	return cloned;
}
